
export class SandningsloggTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        Sok: "Sök",
        SokText: "Fritext",
        Startdatum: "Apteringsfiler skickade fr.o.m",
        Slutdatum: "t.o.m",
        Status: "Status",
        Gpxnr: "Gpx Nr",
        Maskinnr: "Maskinnr",
        Maskinnummer: "Maskinnummer",
        Maskintyp: "Maskintyp",
        Fabrikat: "Fabrikat",
        Filnamn: "Filnamn",
        Filtyp: "Filtyp",
        Version: "Version",
        Filskapad: "Fil skapad",
        Kuvertskapa: "Fil skickad",
        Kvittoinlast: "Kvitto inläst",
        KvitteratSvar: "Kvitto svar",
        Nummer: "Nummer",
        GPXnummer: "GPXnummer",
        Tillverkare: "Tillverkare",
        Maskingtyp: "Maskintyp",
        Stanford: "Kör på stanford2010",
        SkickaPinFil: "Skicka pin filer för massa",
        Aktiv: "Aktiv",
        FilskickAktiv: "Filskick aktivt",
        Sender: "Sender",
        SenderApteringsfiler: "Masen apteringsfiler",
        SenderProduktionsfiler: "Masen produktionsfiler",
        SkickaApteringsfiler: "Skicka alla aktuella filer",
        SkickaAktuellaOIN: "Skicka aktuella objektfiler",
        RensaLogg: "Rensa loggen",
        tabortLoggConfirmText: "poster har tagits bort för maskinnr",
        pageHeader: "Skickade apteringsfiler",
        gpxnrsaknas: "GPX nummer saknas, behöver kompletteras i maskinregistret."
    };
}
